import { apiClient } from '../../../common/ApiClient';
import { createApiQueryHook } from '../../../common/queryClient/createApiQueryHook';
import {
  OpenEditSessionResponseSchema,
  OpenEditSessionResponseType,
} from '../../../edit-session/schema/EditSessionSchema';
import { SampleEditSessionUrl } from '../SampleEditSessionUrl';

const openSampleEditSession = async (params: { scopeKey: string }) =>
  apiClient
    .post<OpenEditSessionResponseType>(SampleEditSessionUrl.open, params)
    .then((response) => OpenEditSessionResponseSchema.parse(response.data));

export const useSampleEditSessionQuery = createApiQueryHook(
  ['sample-edit-session'],
  openSampleEditSession,
  {
    staleTime: Infinity,
    gcTime: Infinity,
  },
);
